import { createSignal } from 'solid-js'

const [globalCounter, setGlobalCounter] = createSignal(0)

const globalCounterRequests = new Set<number>()
let globalCounterInterval: number | undefined

let globalStartedAt = Date.now()

function startGlobalCounter() {
    if (typeof window === 'undefined') return
    if (globalCounterInterval != null) return

    globalStartedAt = Date.now()

    setGlobalCounter(0)

    globalCounterInterval = window.setInterval(() => {
        setGlobalCounter(v => v + 1)
    }, 1000)
}

function stopGlobalCounter() {
    if (globalCounterInterval == null) return

    clearInterval(globalCounterInterval)
    globalCounterInterval = undefined
}

export function addToGlobalInterval(id: number) {
    globalCounterRequests.add(id)

    if (globalCounterRequests.size === 1) {
        startGlobalCounter()
    }
}

export function removeGlobalInterval(id: number) {
    globalCounterRequests.delete(id)

    if (globalCounterRequests.size === 0) {
        stopGlobalCounter()
    }
}

export function getGlobalNow() {
    return globalStartedAt + globalCounter() * 1000
}

export { globalCounter }
